import { buildDefaultModuleRouteObjects } from "src/system/buildDefaultModuleRouteObjects.ts";
import type { Module } from "src/system/module.types.ts";
import type { ClientConfig } from "src/client-config/getClientConfig.ts";

export const getModuleRouteObjects = ({
  module,
  clientConfig,
}: {
  module: Module;
  clientConfig: ClientConfig;
}) => {
  if (module.routeObjects) {
    return module.routeObjects;
  }

  return buildDefaultModuleRouteObjects({ module, clientConfig });
};
